module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (167).d8687c93.jpg";